// @flow
import type {
  FertilizerOperator,
} from '../types'

// Constants
import { MODEL } from 'fc-model-fertilizers'

// Libs
import composeOperator from 'fc-operations'

// Exports
export const operator: FertilizerOperator = composeOperator({
  model: MODEL,
})

export default operator
